import { render, staticRenderFns } from "./TransactionsForm.vue?vue&type=template&id=4d848493&scoped=true"
import script from "./TransactionsForm.vue?vue&type=script&lang=js"
export * from "./TransactionsForm.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./TransactionsForm.vue?vue&type=style&index=1&id=4d848493&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d848493",
  null
  
)

export default component.exports